import { COLOR_PALETTE } from 'constants/ui';
import { getConditionalObject } from 'utils/data';

// The pending highlight is the shared "pending change" tint — background.highlight resolves to the
// same ADDITIONAL[1] in light and flips to a dark accent on its own (as PendingChangeWrapper does).
// The selected fills are bespoke pale blues with no matching flip token, so they keep the BRAND
// fallback and branch on mode: without this the dark theme kept the near-white fill under light text.
const getPendingBackground = ({ palette }) => palette.background.highlight;

const getSelectedBorder = ({ palette }) =>
  `${palette.mode === 'dark' ? palette.primary.main : COLOR_PALETTE.BRAND[6]} !important`;

const getSelectedBackground = ({ palette }) =>
  `${palette.mode === 'dark' ? palette.background.highlight : COLOR_PALETTE.BRAND[1]} !important`;

const accordionStyles = {
  border: '1px solid',
  backgroundColor: 'initial',
  borderColor: ({ palette }) => `${palette.border.default} !important`,
  borderRadius: '8px',
  boxShadow: 'none',

  '&[data-is-pending="true"]': {
    backgroundColor: getPendingBackground,
  },

  '&.MuiAccordion-root': {
    px: 1.5,
    py: 3,
  },

  '&.MuiAccordion-root.Mui-expanded': {
    m: 0,
  },

  '& .MuiAccordionSummary-root': {
    p: 0,
  },

  '& .MuiAccordionSummary-content': {
    alignSelf: 'flex-start',
    m: 0,

    '&.Mui-expanded': {
      m: 0,
      mb: 3,
    },
  },

  '& .MuiAccordionSummary-expandIconWrapper': {
    alignSelf: 'flex-start',
  },

  '& .MuiAccordionDetails-root': { m: 0, p: 0 },

  h3: {
    fontSize: 16,
    fontWeight: 700,
    color: ({ palette }) => palette.text.secondary,
  },

  '&:before': {
    height: 0,
  },
};

export const getAccordionStyles = ({ isAccordionVisible, height, isSelected }) => ({
  ...accordionStyles,
  ...getConditionalObject(!isAccordionVisible, { minHeight: height }),
  ...getConditionalObject(isSelected, {
    borderColor: getSelectedBorder,
    backgroundColor: getSelectedBackground,
  }),
});
